module.exports = __webpack_public_path__ + "img/lock.d4e7fcf7.svg";